export const loadTrustPayScript = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (typeof window.TrustPayApi !== 'undefined') {
      console.info('TrustPay script already loaded');
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://tpgw.trustpay.eu/js/v1.js';
    script.async = true;
    script.onload = () => {
      console.info('TrustPay script loaded');
      resolve();
    };
    script.onerror = (err) => {
      console.error('Failed to load TrustPay script', err);
      reject(new Error('TrustPay script load failed'));
    };
    document.head.appendChild(script);
  });
};
